import { jsx as _jsx } from "react/jsx-runtime";
import { RichTextNodeType } from '@dossierhq/core';
import { initializeMultipleSelectorState, MultipleSelectorStateActions, reduceMultipleSelectorState, TagInputSelector, } from '@dossierhq/design';
import { useEffect, useMemo, useReducer } from 'react';
import { REQUIRED_NODES_PLACEHOLDER, RichTextNodePlaceholders, SchemaEditorActions, sortRichTextNodesWithPlaceholders, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
const RichTextNodesNotInPlaceholders = [
    RichTextNodeType.heading,
    RichTextNodeType.entity,
    RichTextNodeType.entityLink,
    RichTextNodeType.link,
    RichTextNodeType.component,
];
function useSynchronizeMultipleSelectorState(fieldSelector, selectedIds, dispatchSchemaEditorState) {
    const items = useMemo(() => {
        const allNodes = [
            ...RichTextNodePlaceholders.map((it) => it.name),
            ...RichTextNodesNotInPlaceholders,
        ];
        sortRichTextNodesWithPlaceholders(allNodes);
        const result = allNodes.map((it) => ({
            id: it,
            removable: it === REQUIRED_NODES_PLACEHOLDER.name ? selectedIds.length <= 1 : true,
        }));
        return result;
    }, [selectedIds.length]);
    const [state, dispatch] = useReducer(reduceMultipleSelectorState, { items, selectedIds }, initializeMultipleSelectorState);
    useEffect(() => {
        dispatchSchemaEditorState(new SchemaEditorActions.ChangeFieldAllowedRichTextNodes(fieldSelector, state.selectedIds));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedIds]);
    useEffect(() => {
        dispatch(new MultipleSelectorStateActions.SetSelection(selectedIds));
    }, [selectedIds]);
    useEffect(() => {
        dispatch(new MultipleSelectorStateActions.UpdateItems(items));
    }, [items]);
    return { state, dispatch };
}
export function RichTextNodeSelector({ fieldSelector, richTextNodes, dispatchSchemaEditorState, }) {
    const { state, dispatch } = useSynchronizeMultipleSelectorState(fieldSelector, richTextNodes, dispatchSchemaEditorState);
    return (_jsx(TagInputSelector, { clearLabel: "Clear", itemTag: (item) => ({ tag: item.id, transform: '' }), state: state, dispatch: dispatch }));
}
//# sourceMappingURL=RichTextNodeSelector.js.map